 <template>
  <v-dialog v-model="show" width="50%">
    <v-card>
      <v-card-title>
        <h2>{{$t('B0400.titles[4]')}}</h2>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>{{$t('app.labels.forecastDeliveryDate')}}:{{sa.forecastDeliveryDate}}</v-flex>
          <v-flex xs12>{{$t('app.labels.sjlWarehouseName')}}:{{sa.sjlWarehouseName}}</v-flex>
          <v-flex xs12>
            <date-picker :label="$t('app.labels.eta')" :min="sa.etd" v-model="sa.eta" />
          </v-flex>
          <v-flex xs12>
            <date-picker :label="$t('app.labels.etd')" :max="sa.eta" v-model="sa.etd" />
          </v-flex>
          <v-flex xs12>
            <v-text-field :label="$t('app.labels.shipName')" v-model="sa.shipName" />
          </v-flex>
          <v-flex xs12>
            <v-text-field :label="$t('B0400.labels.voyageNo')" v-model="sa.volNo"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-btn @click="show=false" class="mr-3">{{$t('app.buttons.back')}}</v-btn>
        <v-btn @click="confirm" class="mr-3">{{$t('app.buttons.confirm')}}</v-btn>
      </v-card-actions>
    </v-card>
    <eta-update-confirm-dialog @reset="reset" ref="etaUpdateConfirmDialog"></eta-update-confirm-dialog>
  </v-dialog>
</template>
<script>
import EtaUpdateConfirmDialog from './EtaUpdateConfirmDialog'

export default {
  props: ['sa'],
  components: {
    EtaUpdateConfirmDialog
  },
  data() {
    return {
      show: false,
      order: {}
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    confirm() {
      this.$refs.etaUpdateConfirmDialog.popup()
    },
    reset() {
      this.$http
        .put(`shipping-advices/${this.sa.id}/etaUpdate`, this.sa)
        .then(() => {
          this.$message('', this.$t('app.messages.resetSuccess'))
        })
    }
  }
}
</script>
